<!-- Details of failure -->
<div class="update-user-password-results">
  <div class="create-results" *ngIf="requestFailed()">
    <div class="label">
      <p>{{returnErrorMessage()}}</p>
      <div class="icon">
        <mat-icon class="sub--icon error-color">highlight_off</mat-icon>
      </div>
      <p class="close-text">{{errorCauseMessage}}</p>
    </div>
  </div>
  <!-- Details of success -->
  <div class="create-results" *ngIf="!requestFailed()">
    <div class="label">
      <p>{{returnSuccessMessage()}}</p>
      <div class="icon">
        <mat-icon class="sub--icon success-color">check_circle_outline</mat-icon>
      </div>
      <p class="close-text">You can now close the wizard</p>
    </div>
  </div>
</div>
